import { getAnalytics, isSupported, logEvent } from "firebase/analytics";
import { app } from "../firebase";

export const trackEvent = async (
  eventName: string,
  params?: Record<string, string | number | boolean>,
): Promise<void> => {
  if (!(await isSupported())) return;

  logEvent(getAnalytics(app), eventName, params);
};
